import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonItem, IonList, IonListHeader, IonModal, IonRow, IonTitle, IonToolbar } from '@ionic/react'
import { alert, arrowForward, close, happy, helpCircle, informationCircle, location, mic, micCircle } from 'ionicons/icons'
import React, {useState} from 'react'
import { SafetyPadding } from '../../components/SafetyPadding'
import Api from '../../services/Api'

interface ComponentProps {
  handleWalkType: Function
  hasTalk: boolean
  hasCoordinates: boolean
  slideNext: Function
  cancelCreate: Function
  checkIfMapSlide: Function
  id: number
}

const CreateWalkType = ({ handleWalkType, cancelCreate, checkIfMapSlide, id } : ComponentProps) => {
  const api = Api.getInstance()
  const [modalOpen, setModalOpen] = useState(false)

  const meetInfo = () => <IonRow><IonListHeader><h2 className="color_blue">Info:</h2></IonListHeader>
  <p>{api.tr('tipsandinfo_infotext')}</p>
    <IonList>
      <IonListHeader><h2 className="color_blue">{api.tr('tipsandinfo_tankpa')}</h2></IonListHeader>
      <IonList>
        <IonItem>
          <IonIcon color="primary" icon={location} slot="start"/>
          {api.tr('tipsandinfo_iflocation')}
          </IonItem>
        <IonItem>
          <IonIcon color="primary" icon={mic} slot="start"/>
          {api.tr('tipsandinfo_ifdistance')}
          </IonItem>
        <IonItem>
          <IonIcon color="primary" icon={alert} slot="start"/>
          {api.tr('tipsandinfo_decide')}
          </IonItem>
        <IonItem>
          <IonIcon color="primary" icon={happy} slot="start"/> 
            {api.tr('tipsandinfo_contact')}
          </IonItem>
      </IonList>
    </IonList></IonRow>

  const TypePicker = (title: string, icon: any, text: string, type: string) => {
    return <IonCard className="p-2 m-4">
    <IonCardHeader>
      <IonRow >
        <IonCol size="1" className="flex justify-start items-center">
          <IonIcon icon={icon} size="large" color="primary"/>
        </IonCol>
        <IonRow className="flex justify-start items-center">
          <IonCardTitle mode="md" >
            <h2 className="color_blue">{title}</h2>
          </IonCardTitle>
        </IonRow>
      </IonRow>
      <IonCardSubtitle class="p-2">{text}</IonCardSubtitle>
    </IonCardHeader>
    <IonCardContent>
      <IonRow className="flex justify-end items-center">
        <IonButton onClick={() => {
          handleWalkType(setType(type))
          checkIfMapSlide(id, type)
        }}>
          {api.tr('Choose_button')}
          <IonIcon icon={arrowForward}/>
        </IonButton>
      </IonRow>
    </IonCardContent>
  </IonCard>
  }

  const setType = (type: string) => {
    let walkType = {
      hasCoordinates: false,
      hasTalk: false
    }

    if(type === 'hasTalk') {
      walkType = {
        hasCoordinates: false,
        hasTalk: true
      }
    } else if(type === 'hasCoord') {
      walkType = {
        hasCoordinates: true,
        hasTalk: false
      }
    } else {
      walkType = {
        hasCoordinates: true,
        hasTalk: true
      }
    }
    return walkType
  }

  return (
    <IonContent>
      <IonGrid>
        <IonRow className="p-2 flex justify-center mt-6">
          <h1 className="my-4 color_blue">{api.tr('HowCarry_walk')}</h1>
        </IonRow>
        <IonRow className="p-2 m-4 flex justify-end">
          <IonButton 
            fill="outline" 
            size="small" 
            onClick={() => setModalOpen(true)}>
            <IonIcon icon={informationCircle}/> Tips
          </IonButton>
        </IonRow>
        {TypePicker(api.tr('Meet_In_person'), location, api.tr('Meet_in_person_description'), 'hasCoord')}
        {TypePicker(api.tr('Remote_walk'), micCircle, api.tr('remotewalk_info'), 'hasTalk')}  
        {TypePicker(api.tr('BookedPerson_choice'), helpCircle, api.tr('upto_person_info'), 'hasBoth')}
        <IonRow>
          <IonButton 
            color="danger"
            onClick={() => {
              cancelCreate()
            }}
            expand="block" 
            fill="clear"
            className="m-2 fullWidth">
            {api.tr('cancel')}
          </IonButton>
        </IonRow>
      </IonGrid>
      <SafetyPadding/>
      <IonModal 
        className="modal_centered"
        isOpen={modalOpen} 
        onDidDismiss={() => setModalOpen(false)}>
        <IonHeader className="p-2">
          <IonToolbar>
            <IonTitle>
            {api.tr('tipsandinfo_top')}
            </IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setModalOpen(false)}>
                <IonIcon icon={close} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonGrid  className="p-2">
          {meetInfo()}
        </IonGrid>
      </IonModal>
    </IonContent>
  )
}

export default CreateWalkType